export const TmetricSettingsState = {
  tmetricAPIKeyValid: null,
  tmetricEnableDetails: false,
  tmetricSettings: {},
  tmetricSettingsLoading: false,
  tmetricWorkspaceName: null,
  tmetricWorkspaces: null,
}
